<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.selfService.contactQuest') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.selfService.contactDescription') }}
    </p>
    <div class="w-full radio-group">
      <zt-radio-button
        :value="'true'"
        v-model="selected"
        name="contact"
        @change="update"
      >
        <span class="custom-label">{{ $t('message.selfService.radioOk') }}</span>
      </zt-radio-button>
    </div>
    <div class="w-full">
      <zt-radio-button
        :value="'false'"
        v-model="selected"
        name="contact"
        @change="update"
      >
        <span class="custom-label">{{ $t('message.selfService.radioNot') }}</span>
      </zt-radio-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnableContactUpdate',
  inject: ['configurationState', 'setParams'],
  data() {
    return {
      selected: 'false'
    }
  },
  created() {
    this.selected = this.configurationState.params.contact.enable.toString()
  },
  methods: {
    update() {
      const enable = (/^(true|1)$/i).test(this.selected) && !!this.selected
      this.setParams('contact', { enable })
    }
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #2D2D2D;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
::v-deep {
  .zt-radiobutton {
    label {
      padding-top: 3px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}
</style>